<app-grid-simmer
  class="search-page"
  *ngIf="shimmerStatus.language"
></app-grid-simmer>
<section class="related-search lang-sect" *ngIf="!shimmerStatus.language">
  <div class="container" *ngIf="!isSearch">
    <div class="custome-set">
      <div class="section-head section-head ml-0">
        <h2>{{ "HOME.LANGUAGES" | translate }}</h2>
      </div>
    </div>

    <div
      class="d-flex flex-wrap custome-set language-row"
      *ngIf="languageData?.length > 0"
    >
      <div class="series-box" *ngFor="let language of languageData">
        <div
          routerLink="/language-list/{{ language?.slug }}/movies"
          class="lang-bg ratio-16-9"
        >
          <h3 class="h3-absolute">{{ language | languageTranslate }}</h3>
        </div>
      </div>
    </div>
    <div class="record-not-available" *ngIf="languageData.length == 0">
      <div class="text-center">
        <img src="assets/images/no-recoard-playlist.png" />
        <p class="no-recored-content text-secondary">{{ "RECORD_NOT_FOUND" | translate }}</p>
      </div>
    </div>
  </div>
</section>
